import React, {useEffect, useState} from 'react';
import {IonPage, IonContent, IonIcon, IonModal, IonDatetime, IonCol, IonRow} from '@ionic/react';
import {calendarOutline} from "ionicons/icons";
import NewsLetterCard from "../components/NewsLetterCard";
import {actionToGetMemberPanelNewsLetterByFilter} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "../components/Loader/FacebookLoader";
import NoDataFoundOrSelectedDiv from "../components/NoDataFoundOrSelectedDiv";


export default function NewsletterDesktopPage({renderHeaderPage}) {
    const [tempYear, setTempYear] = useState(new Date().getFullYear());
    const [isCustomYearPickerOpen, setIsCustomYearPickerOpen] = useState(false);
    const { newsLettersDataState,selectedNewsLetterDateFilter,setSelectedNewsLetterDateFilter } = useStore();
    const { newsLettersData, loading,totalCount } = newsLettersDataState;
    const isFetchingRef = React.useRef(false); // prevent multiple calls
    const observerRef = React.useRef(null);

    const callFunctionToFilterNewsLetterData = async (isLoad = true,isPastEvent)=>{
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        const payload = {};
        if (isPastEvent) payload.news_year = isPastEvent;
        await actionToGetMemberPanelNewsLetterByFilter(isLoad,payload);
        isFetchingRef.current = false;
    }

    const lastEventsElementRef = React.useCallback(
        (node) => {
            if (observerRef.current) observerRef.current.disconnect();

            observerRef.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && newsLettersData?.length < totalCount) {
                    callFunctionToFilterNewsLetterData(false,selectedNewsLetterDateFilter); // Load next page
                }
            });

            if (node) observerRef.current.observe(node);
        },
        [callFunctionToFilterNewsLetterData,newsLettersData,totalCount]
    );

    useEffect(() => {
        callFunctionToFilterNewsLetterData(true,new Date().getFullYear());
    },[])

    const handleYearChange = () => {
        setSelectedNewsLetterDateFilter(tempYear);
        setIsCustomYearPickerOpen(false);
        callFunctionToFilterNewsLetterData(true,tempYear);
    };

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="feed-content page-content">
                <div className="desktop-contain-feed-newsletter">
                    <IonRow>
                        <IonCol size="12" sizeMd="12">
                            <h1 className="m-0 p-heading">Newsletter</h1>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="12" sizeMd="12">
                            <div className="desktop_events_filter newsletter-filter">
                                    <div className="desktop_events_filter_grid_col">
                                        <div onClick={() => setIsCustomYearPickerOpen(true)}
                                             className={`events_tab_button`}>
                                            <IonIcon icon={calendarOutline} slot="start"/> Select Year
                                        </div>
                                    </div>
                                    <div className="desktop_events_filter_grid_col">
                                        <div className={`events_tab_button active`}>
                                            {selectedNewsLetterDateFilter}
                                        </div>
                                    </div>
                            </div>
                        </IonCol>
                    </IonRow>
                    <div className="feed-list desktop-contain-feed">
                        {(loading) ?
                            <div className="job-list">
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                            :
                            (newsLettersData && newsLettersData?.length > 0) ?
                                <>
                                    {newsLettersData.map((event, index) => {
                                        if (index === newsLettersData.length - 1) {
                                            return (
                                                <div ref={lastEventsElementRef} key={event.id}>
                                                    <NewsLetterCard post={event}/>
                                                </div>
                                            );
                                        }
                                        return (
                                            <NewsLetterCard key={event.id} post={event}/>
                                        );
                                    })}
                                </>
                                :
                                <div className="job-list">
                                    <NoDataFoundOrSelectedDiv/>
                                </div>
                        }
                    </div>
                </div>
            </IonContent>
            <IonModal breakpoints={[0, 0.3]} initialBreakpoint={0.3} isOpen={isCustomYearPickerOpen}
                      onDidDismiss={handleYearChange}>
                <IonDatetime
                    presentation="year"
                    className={"bottom_date_picker"}
                    min={2000}
                    onIonChange={(e) => {
                        const year = new Date(e.detail.value).getFullYear();
                        setTempYear(year);
                    }}
                    value={tempYear.toString()}
                />
            </IonModal>
        </IonPage>
    );
}
